import React from 'react';
import { XCircle } from 'lucide-react';
import { Button } from '../ui';

export const RetryModal = ({ isOpen, onClose, onRetry, errorMessage }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose}></div>

        <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
          <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                <XCircle className="h-6 w-6 text-red-600" />
              </div>
              <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <h3 className="text-lg font-semibold leading-6 text-gray-900">
                  充值失败
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-gray-500 mb-3">
                    可能人太多了，是否继续重试？
                  </p>
                  {errorMessage && (
                    <div className="bg-red-50 border border-red-200 rounded-lg p-3 mb-3">
                      <p className="text-sm text-red-700">{errorMessage}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <Button
              onClick={onRetry}
              className="sm:ml-3 sm:w-auto w-full"
            >
              继续重试
            </Button>
            <Button
              variant="outline"
              onClick={onClose}
              className="mt-3 sm:mt-0 sm:w-auto w-full"
            >
              取消
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};